<div class="tab-list-header">
    <div class="content-wrapper">
        <a
            class="tab-list-item active"
            [class.active]="isActiveTab(UPCOMING)"
            [routerLink]="[upcomingLink]"
        >
            <span>{{ "APPOINTMENT-OVERVIEW.TAB.UPCOMING" | translate }}</span>
        </a>
        @if (!hideTabBasedOnInstitution) {
        <a
            class="tab-list-item"
            [class.active]="isActiveTab(REQUESTS)"
            [routerLink]="[requestLink]"
        >
            <span>
                {{ "APPOINTMENT-OVERVIEW.TAB.REQUESTS" | translate }}
                <span class="badge" [class.green]="(openRequests$ | async) > 0">
                    {{ openRequests$ | async }}
                </span>
            </span>
        </a>
        }
        <a
            class="tab-list-item"
            [class.active]="isActiveTab(HISTORY)"
            [routerLink]="[historyLink]"
        >
            <span>{{ "APPOINTMENT-OVERVIEW.TAB.HISTORY" | translate }}</span>
        </a>
    </div>
</div>
@if (isInit$ | async) {
<div class="dashboard-container">
    <div class="container-fluid">
        <div class="preloader-container">
            <h3 class="preloader-container-message">
                {{ "APPOINTMENT-OVERVIEW.APPOINTMENTS-LOADING" | translate }}
            </h3>
        </div>
    </div>
</div>
}
<router-outlet></router-outlet>
